export default "__VITE_ASSET__CdU8oUl$__"